import { Button } from 'react-bootstrap';
import * as React from 'react';
import { windowSize } from '../../../../../../../../hooks/windowSize';

export const CallNowButton = ({ isBlock = false }) => {
  const isMobile = windowSize().isMobile;

  const handleCallNow = () => {
    if (isMobile) {
      window.open('tel:03332349913', '_self');
    } else {
      window.open('https://www.admiral.com/contact-us/travel', '_blank');
    }
  }

  return (
    <Button
      bsStyle="primary"
      type="button"
      onClick={handleCallNow}
      block={isBlock}
      className={isBlock ? 'functional-button' : 'medium-width pull-right functional-button'}>
      CALL NOW
    </Button>
  )
}
